export const CREATE_SPIN_RATE_REQUEST = "CREATE_SPIN_RATE_REQUEST";
export const CREATE_SPIN_RATE_SUCCESS = "CREATE_SPIN_RATE_SUCCESS";
export const CREATE_SPIN_RATE_FAIL = "CREATE_SPIN_RATE_FAIL";
export const RESET_DELETE_SPIN_RATE = "RESET_DELETE_SPIN_RATE";
export const FETCH_SPIN_RATES_REQUEST = "FETCH_SPIN_RATES_REQUEST";
export const FETCH_SPIN_RATES_SUCCESS = "FETCH_SPIN_RATES_SUCCESS";
export const FETCH_SPIN_RATES_FAIL = "FETCH_SPIN_RATES_FAIL";
export const UPDATE_SPIN_RATE_REQUEST = "UPDATE_SPIN_RATE_REQUEST";
export const UPDATE_SPIN_RATE_SUCCESS = "UPDATE_SPIN_RATE_SUCCESS";
export const UPDATE_SPIN_RATE_FAIL = "UPDATE_SPIN_RATE_FAIL";
export const DELETE_SPIN_RATE_REQUEST = "DELETE_SPIN_RATE_REQUEST";
export const DELETE_SPIN_RATE_SUCCESS = "DELETE_SPIN_RATE_SUCCESS";
export const DELETE_SPIN_RATE_FAIL = "DELETE_SPIN_RATE_FAIL";
export const FETCH_SPIN_RATE_REQUEST = "FETCH_SPIN_RATE_REQUEST";
export const FETCH_SPIN_RATE_SUCCESS = "FETCH_SPIN_RATE_SUCCESS";
export const FETCH_SPIN_RATE_FAIL = "FETCH_SPIN_RATE_FAIL";
